
import React, { useState } from 'react';
import { ExtendedFormTemplate } from '../types/formTypes';
import FormPreviewHeader from './form-preview/FormPreviewHeader';
import FormPreviewSection from './form-preview/FormPreviewSection';

interface FormBuilderPreviewProps {
  formTemplate: ExtendedFormTemplate;
}

const FormBuilderPreview: React.FC<FormBuilderPreviewProps> = ({ formTemplate }) => {
  const [formData, setFormData] = useState<Record<string, any>>({});
  
  const handleFieldChange = (fieldId: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [fieldId]: value
    }));
  };
  
  // Get the background color from the form template or use green-50 as default
  const bgColor = formTemplate?.bg_color || 'green-50';
  
  return (
    <div className="flex flex-col">
      <div className="overflow-y-auto max-h-[calc(100vh-12rem)] pb-4">
        <div className={`bg-${bgColor} rounded-lg p-6 w-full max-w-[640px] mx-auto`}>
          {/* Form header with title and description */}
          <div className="p-5 mb-6 bg-white rounded-lg border border-gray-200">
            <FormPreviewHeader 
              title={formTemplate.title} 
              description={formTemplate.description || undefined} 
            />
          </div>
          
          {/* Display all sections without tabs */}
          {formTemplate.definition.sections.map((section, index) => (
            <div key={index} className="mb-8">
              <FormPreviewSection
                title={section.title}
                description={section.description}
                fields={section.fields}
                formData={formData}
                handleFieldChange={handleFieldChange}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FormBuilderPreview;
